import {
  parse,
  addYears,
  addDays,
  isAfter,
  startOfDay,
  getMonth,
  getDate,
} from 'date-fns/fp'
import fp from 'lodash/fp'
import { Sukupuoli } from 'common/src/vtj/Sukupuoli.enum'

type SsnPuctuation =
  | '+'
  | '-'
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'Y'
  | 'X'
  | 'W'
  | 'V'
  | 'U'

type SsnCentury = '18' | '19' | '20'

export const formatSsn = (ssn: string): string => ssn.toUpperCase().trim()

const FEBRUARY = 1
const dateOfMajority = 18
const add18Years = addYears(dateOfMajority)

export const getDateOfMajority = (birthday: Date): Date => {
  const leapDayFix =
    getMonth(birthday) === FEBRUARY && getDate(birthday) === 29
      ? addDays(1)
      : fp.identity
  return leapDayFix(add18Years(birthday)) as Date
}

export const getDateOfMajorityBySsn = (ssn: string): Date => {
  return getDateOfMajority(getBirthdayFromSsn(ssn))
}

export const isAdult = (birthday: Date, currentDate = new Date()): boolean => {
  const today = startOfDay(currentDate)
  const dateOfMajority = startOfDay(getDateOfMajority(birthday))
  return !isAfter(today)(dateOfMajority)
}

export const isAdultBySsn = (
  ssn: string,
  currentDate = new Date()
): boolean => {
  const birthday = getBirthdayFromSsn(ssn)
  return isAdult(birthday, currentDate)
}

export const getBirthdayFromSsn = (ssn: string): Date => {
  const punctuation = ssn.charAt(6) as SsnPuctuation
  const dateMonth = ssn.substring(0, 4)
  const yearSuffix = ssn.substring(4, 6)
  const birthday = `${dateMonth}${getSsnCentury(punctuation)}${yearSuffix}`
  return parse(new Date(), 'ddMMyyyy')(birthday)
}

export const getGenderFromSsn = (ssn: string): Sukupuoli => {
  const genderValue = parseInt(ssn.substring(7, 10))
  return genderValue % 2 === 0 ? Sukupuoli.NAINEN : Sukupuoli.MIES
}

const getSsnCentury = (punctuation: SsnPuctuation): SsnCentury => {
  switch (punctuation) {
    case '+':
      return '18'
    case '-':
    case 'Y':
    case 'X':
    case 'W':
    case 'V':
    case 'U':
      return '19'
    case 'A':
    case 'B':
    case 'C':
    case 'D':
    case 'E':
    case 'F':
      return '20'
  }
}
